module.exports = __webpack_public_path__ + "static/media/ecommers2.d8dbb56e.PNG";